import { render } from "./ExceptionPage.vue?vue&type=template&id=4663c6bd&scoped=true"
import script from "./ExceptionPage.vue?vue&type=script&lang=js"
export * from "./ExceptionPage.vue?vue&type=script&lang=js"

import "./ExceptionPage.vue?vue&type=style&index=0&id=4663c6bd&lang=less&scoped=true"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4663c6bd"]])

export default __exports__